import { calcColumnBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/columnBarConfig'
import { wireMoEEvents } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/marginOfError'
import { CHART_HEIGHT } from '@aytm/app/stats/page/question-views/components/lib/constants'

export const calcBarOptions = props => {
  const result = calcColumnBarOptions(props)

  if (!result) return null

  const { options } = result
  const { chartLegendMode } = props

  options.chart.type = 'bar'
  options.chart.defaultSeriesType = 'bar'
  options.chart.marginRight = 43
  options.chart.marginBottom = 50
  options.chart.marginLeft = chartLegendMode === 'short' ? 85 : 130

  options.plotOptions.bar = { groupPadding: 0.05 }

  delete options.xAxis.labels.step
  delete options.xAxis.labels.y

  const series = options.series || []
  const barsCount = series[0]?.data?.length === 1 ? series.length : series[0]?.data?.length || 0

  if (0 < barsCount) {
    const chartHeight = options.chart.height || CHART_HEIGHT
    const correctedHeight = chartHeight + 40 * (barsCount - 7)
    options.chart.height = correctedHeight
    if (options.chart.backgroundColor?.linearGradient) {
      options.chart.backgroundColor.linearGradient = [0, 0, 0, correctedHeight]
    }
  }

  wireMoEEvents(options, props) // MoE hover overlay (no-op without props.moeController)

  return result
}
